import type { FlowItem } from "../Types/BookShipmentFlowItemType";

export function bookShipmentGetNextInFlow(
  flow: Array<FlowItem>,
  currentIdentifier: string,
): string {
  const currentIndex = flow.findIndex(function (item) {
    return item.identifier === currentIdentifier;
  });

  if (currentIndex === -1) {
    console.error(`Item not found`, { currentIdentifier, flow });
    throw new Error(`Item not found ${currentIdentifier}`);
  }

  const next = flow[currentIndex + 1];
  if (next === undefined) {
    // Last element, so there is no next
    throw new Error("Already at end of flow");
  }

  return next.identifier;
}
